export const bgData = [
  {
    name: 'ams-live',
    bg: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/ams-live21/images/ams_register.jpg'
  },
  {
    name: 'gdte-live',
    bg: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/GDT/images/register_bg.jpg'
  }
]